import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { I18n } from "@aws-amplify/core";
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";

import { setBreadcrumb } from "../../actions/common";
import PersonalInfo from "./PersonalInfo";
import Settings from "./Settings";
import colors from "../../assets/style/colors";

const CustomTab = withStyles({
  root: {
    textTransform: "initial",
    fontSize: "1em",
    fontWeight: "400",
    color: colors.black87,
    borderBottom: "1px solid " + colors.veryLighPink,
  },
  selected: {
    color: colors.black87,
    fontWeight: "500",
    borderBottom: "3px solid " + colors.primary,
  },
})(Tab);

const styles = {
  tabs: {
    marginBottom: "24px",
  },
};

const MyAccount = (props) => {
  props.dispatch(
    setBreadcrumb([
      {
        name: I18n.get("topbar_myAccount"),
      },
    ])
  );

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  return (
    <Grid container direction="column" className="height-100">
      <Grid item xs className="mainContainer" style={getWidth() < 478 ? { padding: "5px" } : { padding: "24px" }}>
        <Box className="mainContent" style={{ padding: "5px" }}>
          <Grid
            container
            direction="column"
            alignItems="stretch"
            alignContent="center"
          >
            <Grid item>
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                centered
                className={props.classes.tabs}
              >
                <CustomTab style={getWidth() < 478 ? { fontSize: "0.8em" } : {}} label={I18n.get("account_personalInfo")} />
                <CustomTab style={getWidth() < 478 ? { fontSize: "0.8em" } : {}} label={I18n.get("account_settings")} />
              </Tabs>
            </Grid>
            {value === 0 && <PersonalInfo />}
            {value === 1 && <Settings history={props.history} />}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default connect()(withStyles(styles)(MyAccount));
